import { BASE_URL } from "../config/settings";
import httpRequest from "../utils/httpRequest";

export const signIn = async (payload) => {
  return await httpRequest(`${BASE_URL}/account/login`, "post", payload);
};

export const activateAccount = async (userId) => {
  return await httpRequest(`${BASE_URL}/account/activate-account/${userId}`);
};

export const sendOtp = async (email) => {
  return await httpRequest(`${BASE_URL}/account/password-reset-otp?email=${email}`, "post" );
};
export const forgotPassword = async (payload) => {
  return await httpRequest(`${BASE_URL}/account/reset-password`, "post", payload);
};
